import { render, staticRenderFns } from "./CombinationSummary.vue?vue&type=template&id=1f1d5709&scoped=true&lang=html&"
import script from "./CombinationSummary.vue?vue&type=script&lang=js&"
export * from "./CombinationSummary.vue?vue&type=script&lang=js&"
import style0 from "./CombinationSummary.vue?vue&type=style&index=0&id=1f1d5709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d5709",
  null
  
)

export default component.exports